module.exports = __webpack_public_path__ + "static/media/invoice64.fbc449a3.png";